module.exports = __webpack_public_path__ + "static/media/Print.44703d0b.svg";